export enum EVENTS {
  ElementClicked = "redventures.usertracking.v3.ElementClicked",
  ElementViewed = "redventures.usertracking.v3.ElementViewed",
  ProductClicked = "redventures.ecommerce.v1.ProductClicked",
  ProductViewed = "redventures.ecommerce.v1.ProductViewed",
  ProductLoaded = "redventures.ecommerce.v1.ProductLoaded",
  ConversionTracked = "core.conversions.ConversionTracked.v2",
  FieldInputted = "redventures.usertracking.v3.FieldInputted",
  FieldSelected = "redventures.usertracking.v3.FieldSelected",
  FieldViewed = "core.fieldViewed.v1",
  FormSubmitted = "redventures.usertracking.v3.FormSubmitted",
  FormViewed = "redventures.usertracking.v3.FormViewed",
  FormStarted = "redventures.usertracking.v3.FormStarted",
  FormContinued = "redventures.usertracking.v3.FormContinued",
  DAPICorrelation = "2u.dapi.ConsentCorrelation.v2",
}
